/**
 * Where a custom field came from. Integration-origin fields carry a
 * `metaQuestionKey` (set when a Meta campaign question is switched on) and are
 * machine-managed: the sync owns their `name` and options. Everything else is
 * a field the tenant created by hand.
 */
export type CustomFieldOrigin = "manual" | "campaign";

export const isAutoCreatedField = (f: {
  metaQuestionKey?: string | null;
}): boolean => f?.metaQuestionKey != null;

export const originOf = (f: {
  metaQuestionKey?: string | null;
}): CustomFieldOrigin => (isAutoCreatedField(f) ? "campaign" : "manual");
